import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en";
import ru from "./ru";
import uz from "./uz";
import type { Locale } from "@/api/types/Locale";

export const LOCALES: Locale[] = ["en", "uz", "ru"];
const STORAGE_KEY = "mixla-locale";

/** Language before sign-in (remembered per browser). After sign-in the user's profile wins. */
export function storedLocale(): Locale {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && (LOCALES as string[]).includes(v)) return v as Locale;
  } catch {
    // storage unavailable
  }
  return "en";
}

export function setLocale(locale: Locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // storage unavailable
  }
  document.documentElement.lang = locale;
  if (i18n.language !== locale) void i18n.changeLanguage(locale);
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, uz: { translation: uz }, ru: { translation: ru } },
  lng: storedLocale(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

document.documentElement.lang = i18n.language;

export default i18n;
